import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		fill: "currentColor",
		points: "75.6,38 70.4,32.7 43.5,59.7 31.4,47.6 26.2,52.9 43.4,70.1"
	})
});
export { SvgTick as ReactComponent };
